import { Observable } from 'rxjs';
import { DiaryNote } from '../model/diary-note';

export abstract class DiaryNoteService {
  abstract entityId$: Observable<string>;
  abstract getDiaryNotes(
    entityId: string,
    searchString: string
  ): Observable<DiaryNote.Model[]>;
  abstract getDiaryNoteDefinition(): Observable<DiaryNote.Definition>;
  abstract getDiaryNoteForEdit(
    entityId: string,
    diaryNoteId: string
  ): Observable<DiaryNote.Model>;
  abstract updateDiaryNote(
    entityId: string,
    diaryNoteId: string,
    change: any
  ): Observable<any>;
  abstract deleteDiaryNote(
    entityId: string,
    diaryNoteId: string
  ): Observable<any>;
}
